document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.getElementById('MobileMenu');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
    menu.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', function(){
        menu.hidden = true;
        toggle.setAttribute('aria-expanded','false');
      });
    });
  }

  const packageSelect = document.querySelector('[data-package-select]');
  const packageMap = {
    'Starter': 'Starter — $350/month',
    'Growth': 'Growth — $600/month',
    'Pro': 'Pro — $1,000/month',
    'Elite': 'Elite — $2,000/month'
  };

  function setPackage(plan) {
    if (!packageSelect || !plan) return;
    const desired = packageMap[plan] || plan;
    const option = Array.from(packageSelect.options).find(function(o){
      return o.value === desired || o.value.indexOf(plan) === 0;
    });
    if (option) packageSelect.value = option.value;
  }

  try {
    const planFromUrl = new URLSearchParams(window.location.search).get('plan');
    if (planFromUrl) setPackage(planFromUrl);
  } catch(e) {}

  document.querySelectorAll('.package-cta[data-plan]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      const href = btn.getAttribute('href') || '';
      const plan = btn.getAttribute('data-plan');
      if (href === '#onboarding' || href.endsWith('#onboarding')) {
        e.preventDefault();
        setPackage(plan);
        const target = document.getElementById('onboarding');
        if (target) target.scrollIntoView({behavior:'smooth', block:'start'});
      }
    });
  });

  /* One-click package checkout. Fallback href still works if fetch is unavailable. */
  document.querySelectorAll('[data-direct-checkout][data-variant-id]').forEach(function(button){
    button.addEventListener('click', async function(event){
      if (!window.fetch) return;
      event.preventDefault();
      const variantId = button.getAttribute('data-variant-id');
      if (!variantId || button.classList.contains('is-loading')) return;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');

      try {
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: {'Accept':'application/json'}
        });
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
        });
        if (!response.ok) throw new Error('Unable to add package');
        window.location.assign('/checkout');
      } catch (error) {
        window.location.assign(button.getAttribute('href'));
      }
    });
  });

  /* Existing VISTIQ homepage reel controls. */
  const videoCard = document.querySelector('[data-vistiq-video-card]');
  if (videoCard) {
    const video = videoCard.querySelector('video');
    const soundButton = videoCard.querySelector('[data-video-sound]');
    const closeButton = videoCard.querySelector('[data-video-close]');

    if (video && soundButton) {
      soundButton.addEventListener('click', function(){
        video.muted = !video.muted;
        const soundOn = !video.muted;
        soundButton.setAttribute('aria-pressed', String(soundOn));
        soundButton.setAttribute('aria-label', soundOn ? 'Turn video sound off' : 'Turn video sound on');
        if (video.paused) video.play().catch(function(){});
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', function(){
        if (video) video.pause();
        videoCard.classList.add('is-hidden');
      });
    }
  }

  /* Subtle reveal animation; visible immediately when reduced motion is preferred. */
  const revealTargets = document.querySelectorAll('.section, .hero');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {threshold:0.08, rootMargin:'0px 0px -5% 0px'});
    revealTargets.forEach(function(target){ observer.observe(target); });
  } else {
    revealTargets.forEach(function(target){ target.classList.add('is-visible'); });
  }
});
